import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";
import { GlobalSearch } from "@/components/common/GlobalSearch";
import { Sheet, SheetContent } from "@/components/ui/sheet";
import { cn } from "@/lib/utils";

export function AppLayout() {
    const [mobileOpen, setMobileOpen] = useState(false);
    const [searchOpen, setSearchOpen] = useState(false);

    return (
        <div className="min-h-screen w-full bg-background text-foreground">
            {/* Desktop sidebar */}
            <aside className="fixed inset-y-0 left-0 z-30 hidden w-[var(--sidebar-width)] border-r bg-card md:block">
                <Sidebar onNavigate={() => setMobileOpen(false)} />
            </aside>

            {/* Mobile sidebar (Sheet) */}
            <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
                <SheetContent side="left" className="w-72 p-0">
                    <Sidebar onNavigate={() => setMobileOpen(false)} />
                </SheetContent>
            </Sheet>

            <div className={cn("md:pl-[var(--sidebar-width)]", "flex min-h-screen flex-col")}>
                <Topbar
                    onOpenMobileMenu={() => setMobileOpen(true)}
                    onOpenSearch={() => setSearchOpen(true)}
                />
                <main className="flex-1 p-4 sm:p-6 max-w-[1400px] w-full" data-testid="app-main">
                    <Outlet />
                </main>
            </div>

            <GlobalSearch open={searchOpen} onOpenChange={setSearchOpen} />
        </div>
    );
}
